<template>
	<div>
		<div class="product-add">
			<!--form表单-->
			<el-form size="small" label-width="150px">
				<div class="common-form">支付宝提现设置</div>
				<el-form-item label="appId">
					<el-input v-model="obj.appId" placeholder="请输入" class="max-w460"></el-input>
				</el-form-item>
				<el-form-item label="privateKey">
					<el-input v-model="obj.privateKey" type="textarea" :rows="5" placeholder="请输入"
						class="max-w460"></el-input>
				</el-form-item>
				<el-form-item label="appPublicCert">
					<el-upload class="upload-demo" action="https://ruanchengshangmen.rchz.top/shop/setting.AliPay/file"
						:headers="headers" :on-success="handleSuccess" :on-error="handleError"
						:before-upload="beforeUpload" :show-file-list="false" accept=".crt">
						<el-button size="small" type="primary">上传证书</el-button>
					</el-upload>
					<div class="">
						<i class="el-icon-document"></i>
						<span>{{obj.appPublicCert}}</span>
					</div>
				</el-form-item>
				<el-form-item label="alipayPublicCert">
					<el-upload class="upload-demo" action="https://ruanchengshangmen.rchz.top/shop/setting.AliPay/file"
						:headers="headers" :on-success="handleSuccess1" :on-error="handleError"
						:before-upload="beforeUpload" :show-file-list="false" accept=".crt">
						<el-button size="small" type="primary">上传证书</el-button>
					</el-upload>
					<div class="">
						<i class="el-icon-document"></i>
						<span>{{obj.alipayPublicCert}}</span>
					</div>
				</el-form-item>
				<el-form-item label="alipayRootCert">
					<el-upload class="upload-demo" action="https://ruanchengshangmen.rchz.top/shop/setting.AliPay/file"
						:headers="headers" :on-success="handleSuccess2" :on-error="handleError"
						:before-upload="beforeUpload" :show-file-list="false" accept=".crt">
						<el-button size="small" type="primary">上传证书</el-button>
					</el-upload>
					<div class="">
						<i class="el-icon-document"></i>
						<span>{{obj.alipayRootCert}}</span>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="common-button-wrapper">
			<el-button type="primary" @click="onSubmit">提交</el-button>
		</div>
	</div>
</template>

<script>
	import settingApi from "@/api/setting.js";
	import FileApi from '@/api/file.js';
	import {
		getCookie
	} from "@/utils/base.js";
	export default {
		data() {
			return {
				obj: {
					appPublicCert: '',
					alipayPublicCert: '',
					alipayRootCert: ''
				},
				headers: {
					// 添加认证信息（如token）
					cookie: 'PHPSESSID=' + getCookie('PHPSESSID')
				},
				uploadSuccess: false,
				uploadError: null
			};
		},
		created() {
			this.getDate();
		},
		methods: {
			getDate() {
				let self = this;
				settingApi.aliPayGET({}, true)
					.then(res => {
						self.obj = res.data.vars.values;
					})
					.catch(err => {});
			},
			onSubmit() {
				let self = this;
				settingApi.aliPayPOST(self.obj, true)
					.then(res => {
						if (res.code == 1) {
							this.$message({
								message: res.msg,
								type: "success"
							});
						}
					})
					.catch(err => {
						this.$message({
							message: err.msg,
							type: "warning"
						});
					});
			},
			// 上传前校验
			beforeUpload(file) {
				const isCrt = file.name.endsWith('.crt');
				if (!isCrt) {
					this.uploadError = '请上传.crt格式的证书文件';
					return false;
				}

				// 限制文件大小（可选）
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.uploadError = '文件大小不能超过2MB';
					return false;
				}

				this.uploadError = null;
				return true;
			},

			// 上传成功处理
			handleSuccess(response, file, fileList) {
				this.uploadSuccess = true;
				this.uploadError = null;
				if (response.code == 1) {
					this.obj.appPublicCert = response.data.path
				}
				// 可在这里添加后续处理逻辑，如刷新列表、提示用户等
				this.$message.success('证书上传成功');
			},
			handleSuccess1(response, file, fileList) {
				this.uploadSuccess = true;
				this.uploadError = null;
				if (response.code == 1) {
					this.obj.alipayPublicCert = response.data.path
				}
				// 可在这里添加后续处理逻辑，如刷新列表、提示用户等
				this.$message.success('证书上传成功');
			},
			handleSuccess2(response, file, fileList) {
				this.uploadSuccess = true;
				this.uploadError = null;
				if (response.code == 1) {
					this.obj.alipayRootCert = response.data.path
				}
				// 可在这里添加后续处理逻辑，如刷新列表、提示用户等
				this.$message.success('证书上传成功');
			},

			// 上传失败处理
			handleError(error, file, fileList) {
				this.uploadSuccess = false;
				this.uploadError = '上传失败，请重试';

				// 根据后端返回的错误信息定制提示
				if (error.response && error.response.data && error.response.data.message) {
					this.uploadError = error.response.data.message;
				}

				this.$message.error(this.uploadError);
			},
		}
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/setting/withdraw/index.vue